<!-- <div [class.hidden]="!show"> -->
  <!-- <div class="loader-overlay">
      <span class="loading"></span>
  </div> -->
  <!-- <div *ngIf="show" class="loader-wrapper">
    <div class="loader">
      <div><img src="./assets/images/round.png"></div>
      <div><img src="assets/images/round-1.png"></div>
      <div><img src="assets/images/round-2.png"></div>
    </div>
  </div>
</div> -->

<div [class.hidden]="!show && !isshow">
  <div *ngIf="show || isshow" class="cus-loader">
    <div class="dot-loader">
      <span class="dot"></span>
      <span class="dot two"></span>
      <span class="dot three"></span>
      <span class="dot four"></span>
    </div>
  </div>
</div>
